import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons';

import Authorize from '../../../components/Authorize';
import { CONFIG } from '../../../components/Authorize/permissions/resources';
import cc from '../style.module.scss';

const SrsToggle = ({ show, onToggle }) => {
  const label = show ? 'Hide SRS' : 'Show SRS';
  return (
    <Authorize permissions={CONFIG}>
      <div className={[cc.field, cc.fieldSolo].filter(Boolean).join(' ')}>
        <span>
          <button
            type="button"
            className={[cc.fieldIconBtn, show && cc.fieldIconBtnOn].filter(Boolean).join(' ')}
            onClick={onToggle}
            title={label}
            aria-label={label}
            aria-pressed={show}
          >
            <FontAwesomeIcon icon={show ? faEye : faEyeSlash} />
          </button>
          <span>SRS</span>
        </span>
      </div>
    </Authorize>
  );
};

export default SrsToggle;
